import React from 'react';
import Image from 'assets/banner-header.png';
import { UndraggableImage } from '../shared/UndraggableImage';

export const BannerHeaderImage = React.memo(() => {
  return (
    <UndraggableImage
      position="absolute"
      src={Image}
      width={{ base: 300, md: 400, lg: 500, xl: 600 }}
      right={0}
      bottom={{ base: 0, lg: 10 }}
    />
  );
});
